<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallNumSingleList></CallNumSingleList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../../layouts/BasicLayout';
  import CallNumSingleList from '../../../../components/tsConfig/hytalkPro/system/CallNumSingleList';

  export default {
    name: 'SystemCallNumSingle',
    components: {
      BasicLayout,
      CallNumSingleList
    },
    data() {
      return {
        left: {
          show: false,
          name: ''
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: '111/22222/33333'
        }
      };
    }
  };
</script>

<style scoped>

</style>
